
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Pages
import Layout from './components/Layout';
import LandingPage from './components/LandingPage';
import StoryPage from './StoryPage';
import GetCredits from './components/GetCredits';
import ResetPassword from './components/ResetPassword';
import DocumentsDashboard from './components/dashboard/DocumentsDashboard';
import ScrollToTop from './components/shared/ScrollToTop';
import SalesIQWidget from './components/shared/SalesIQWidget';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import Contact from './components/legal/Contact';
import Support from './components/support/Support';
import { AuthProvider, RequireAuth } from './components/auth/ProtectedApp';

function App() {
  return (
    <Router basename="/">
      <AuthProvider>
        <div className="App">
          <ScrollToTop />
          <SalesIQWidget />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<LandingPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/support" element={<Support />} />
            <Route path="/create" element={<RequireAuth><Layout /></RequireAuth>} />
            <Route path="/get-credits" element={<RequireAuth><GetCredits /></RequireAuth>} />
            <Route path="/dashboard" element={<RequireAuth><DocumentsDashboard /></RequireAuth>} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;


 